import axios from 'axios';
import Api, { api, url } from '../api'
import { toast } from 'react-toastify';
import { deleteCookie, getCookie } from '../../util/Cookie';
import { setGlobalLoader } from '../../context/LoaderContext';

export const PutClientApi = (request, clientId, callBack) => {
    axios.put(`${url}/api/cliente/${clientId}`, request, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch(err => {
            if (err.response?.status === 401 && err.response?.data?.message !== "Login ou senha inválidos") {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
        })
        .finally(() => {
        });
}

export const GetClientApi = (userId, callBack, token = null) => {
    setGlobalLoader(true)
    axios.get(`${url}/api/cliente/${userId}`, {
        headers: {
            "Authorization": `Bearer ${token ? token : getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch(err => {
            if (err.response?.status === 401) {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
        })
        .finally(() => {
            setGlobalLoader(false)
        });
}